var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "order_box",
      attrs: {
        visible: _vm.modals,
        "close-on-click-modal": false,
        title:
          _vm.secondType !== _vm.OrderSecondTypeEnum.Fictitious
            ? "订单发送货"
            : "虚拟商品发货",
        "before-close": _vm.handleClose,
        width: "900px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.modals = $event
        },
      },
    },
    [
      _vm.modals
        ? _c(
            "el-form",
            {
              ref: "formItem",
              attrs: {
                model: _vm.formItem,
                "label-width": "75px",
                rules: _vm.rules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.secondType !== _vm.OrderSecondTypeEnum.Fictitious,
                      expression:
                        "secondType !== OrderSecondTypeEnum.Fictitious",
                    },
                  ],
                  attrs: { label: "配送方式：", prop: "deliveryType" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      directives: [
                        {
                          name: "removeAriaHidden",
                          rawName: "v-removeAriaHidden",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          return _vm.changeRadio(_vm.formItem.deliveryType)
                        },
                      },
                      model: {
                        value: _vm.formItem.deliveryType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formItem, "deliveryType", $$v)
                        },
                        expression: "formItem.deliveryType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "express" } }, [
                        _vm._v("快递配送"),
                      ]),
                      _c("el-radio", { attrs: { label: "noNeed" } }, [
                        _vm._v("无需发货"),
                      ]),
                      _c("el-radio", { attrs: { label: "merchant" } }, [
                        _vm._v("商家送货"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("SendFrom", {
                attrs: { formItem: _vm.formItem, isShowBtn: true },
              }),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.secondType !== _vm.OrderSecondTypeEnum.Fictitious,
                      expression:
                        "secondType !== OrderSecondTypeEnum.Fictitious",
                    },
                  ],
                  attrs: { label: "分单发货：", prop: "isSplit" },
                },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": true,
                      "inactive-value": false,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                    },
                    model: {
                      value: _vm.formItem.isSplit,
                      callback: function ($$v) {
                        _vm.$set(_vm.formItem, "isSplit", $$v)
                      },
                      expression: "formItem.isSplit",
                    },
                  }),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.isSplit,
                          expression: "formItem.isSplit",
                        },
                      ],
                      staticClass: "from-tips",
                    },
                    [_vm._v("可选择表格中的商品单独发货，请谨慎操作！")]
                  ),
                ],
                1
              ),
              _vm.formItem.isSplit
                ? [
                    _c(
                      "el-table",
                      {
                        ref: "multipleSelection",
                        staticClass: "tableSelection",
                        staticStyle: { "padding-left": "75px" },
                        attrs: {
                          data: _vm.productList,
                          "tooltip-effect": "dark",
                          size: "small",
                          "row-key": function (row) {
                            return row.id
                          },
                        },
                        on: { "selection-change": _vm.handleSelectionChange },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            selectable: _vm.selectable,
                            "reserve-selection": true,
                            "min-width": "50",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "商品信息", width: "200" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "acea-row",
                                        staticStyle: {
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "demo-image__preview line-heightOne refundImg",
                                          },
                                          [
                                            _c("el-image", {
                                              attrs: {
                                                src: scope.row.image,
                                                "preview-src-list": [
                                                  scope.row.image,
                                                ],
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "priceBox product-info-text",
                                                staticStyle: { width: "120px" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.productName)
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1732348176
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "规格", "min-width": "120" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "priceBox" }, [
                                      _vm._v(_vm._s(scope.row.sku)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            969154261
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "总数（件）", "min-width": "80" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "priceBox" }, [
                                      _vm._v(_vm._s(scope.row.payNum)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "priceBox textE93323" },
                                      [
                                        _vm._v(
                                          "已发" + _vm._s(scope.row.deliveryNum)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "priceBox textE93323" },
                                      [
                                        _vm._v(
                                          "已退款" + _vm._s(scope.row.refundNum)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3199062075
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "发货数量（件）",
                            "min-width": "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticClass: "priceBox",
                                      attrs: {
                                        disabled:
                                          scope.row.deliveryNum ===
                                          scope.row.payNum,
                                        min: 1,
                                        max:
                                          Number(scope.row.deliveryNum) == 0
                                            ? Number(scope.row.payNum) -
                                              Number(scope.row.refundNum)
                                            : Number(scope.row.payNum) -
                                              Number(scope.row.deliveryNum),
                                        step: 1,
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.limitCount(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row["num"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "num",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row['num']",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3424679953
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-btn-top",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel("formItem")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.putSend("formItem")
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }